import { Outlet } from 'react-router';

export const AnonymousLayout = () => (
  <div className="ippon-layout">
    <main className="ippon-layout--body">
      <Outlet />
    </main>
  </div>
);
